var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down-Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M14.66,82.16,46.82,50,14.66,17.84a2.25,2.25,0,0,1,3.18-3.18L53.18,50,17.84,85.34a2.25,2.25,0,0,1-3.18-3.18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2-2",
    "data-name": "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down-Chevron-2",
    "data-name": "Down-Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1-2",
    "data-name": "Fill-1",
    d: "M47.48,82.16,79.64,50,47.48,17.84a2.25,2.25,0,1,1,3.18-3.18L86,50,50.66,85.34a2.25,2.25,0,1,1-3.18-3.18"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleRight);
export default __webpack_public_path__ + "static/media/chevronDoubleRight.01c4465d84a58d3460726348cbdf8e90.svg";
export { ForwardRef as ReactComponent };